import React from 'react';
import './style.scss';
import { Link } from 'react-router-dom';
import { trackGAEvent } from '../../../shared/helpers';
// import imgPromoEn from '../i/en/56-burger.jpg';
// import imgPromoFr from '../i/fr/56-burger.jpg';
// import imgPromoEn from '../i/en/coffee-generic-en.jpg';
// import imgPromoFr from '../i/fr/coffee-generic-fr.jpg';
// import imgPromoEn from '../i/en/btbms-2022.jpg';
// import imgPromoFr from '../i/fr/btbms-2022.jpg';
// import imgPromoEn from '../i/en/kids-meal-promo-en.jpg';
// import imgPromoFr from '../i/fr/kids-meal-promo-fr.jpg';
// import imgPromoEn from '../i/en/kitkat-turnover-en.jpg';
// import imgPromoFr from '../i/fr/kitkat-turnover-fr.jpg';
// import imgPromoEn from '../i/en/grass-fed-beef.jpg';
// import imgPromoFr from '../i/fr/grass-fed-beef.jpg';
// import imgPromoEn from '../i/en/croissant-egger-en.jpg';
// import imgPromoFr from '../i/fr/croissant-egger-fr.jpg';
 //import imgPromoEn from '../i/en/brewbar-en.jpg';
 //import imgPromoFr from '../i/fr/brewbar-fr.jpg';
//import imgPromoEn from '../i/en/frozen-root-beer-2023.jpg';
//import imgPromoFr from '../i/fr/frozen-root-beer-2023.jpg';
// import imgPromoEn from '../i/en/now-frozen.jpg';
// import imgPromoFr from '../i/fr/now-frozen.jpg';
//import imgPromoEn from '../i/en/btbms-2023.jpg';
//import imgPromoFr from '../i/fr/btbms-2023.jpg';
//import imgPromoEn from '../i/en/kids-pack-2023-en.jpg';
//import imgPromoFr from '../i/fr/kids-pack-2023-fr.jpg';
//import imgPromoEn from '../i/en/chicken-crunchers-2024.jpg';
//import imgPromoFr from '../i/fr/chicken-crunchers-2024.jpg';
//import imgPromoEn from '../i/en/icy-creamy-dreamy-en.jpg';
//import imgPromoFr from '../i/fr/icy-creamy-dreamy-fr.jpg';
//import imgPromoEn from '../i/en/pret-1-coffee-en.jpg';
//import imgPromoFr from '../i/fr/pret-1-coffee-fr.jpg';
//import imgPromoEn from '../i/en/classic-teen-en.jpg';
//import imgPromoFr from '../i/fr/classic-teen-fr.jpg';

//import imgPromoEn from '../i/en/craveably-creamy-en.jpg';
//import imgPromoFr from '../i/fr/craveably-creamy-fr.jpg';
//import imgPromoEn from '../i/en/whistle-dog-en.jpg';
//import imgPromoFr from '../i/fr/whistle-dog-fr.jpg';
//import imgPromoEn from '../i/en/blue-jays-free-fries-en.jpg';
//import imgPromoFr from '../i/fr/blue-jays-free-fries-fr.jpg';
//import imgPromoEn from '../i/en/btbms-2024-en.jpg';
//import imgPromoFr from '../i/fr/btbms-2024-fr.jpg';
//import imgPromoEn from '../i/en/pret-awareness-en.jpg';
//import imgPromoFr from '../i/fr/pret-awareness-fr.jpg';
import imgPromoEn from '../i/en/rewards-en.jpg';
import imgPromoFr from '../i/fr/rewards-fr.jpg';
//import imgPromoEn from '../i/en/mobile-app-en.jpg';
//import imgPromoFr from '../i/fr/mobile-app-fr.jpg';


const SubPromo2 = (props) => {
    // let promo2URL = (props.lang === 'en') ? '/en/update' : '/fr/update';
    //let promo2URL = '/' + props.lang + '/company';
   // let promo2URL = '/' + props.lang + '/our-menu/chicken';
    // let promo2URL = '/' + props.lang + '/our-menu/sides/chocolate-turnover-made-with-kitkat';
    // let promo2URL = '/' + props.lang + '/our-values/our-food/beef';
    // let promo2URL = '/' + props.lang + '/our-menu/breakfast';
   // let promo2URL = '/' + props.lang + '/our-menu/brewbar';
   // let promo2URL = '/' + props.lang + '/our-menu/chicken/whistle-dog';
    //let promo2URL = '/' + props.lang + '/our-menu/brewbar/frozen-aw-root-beer';
   // let promo2URL = '/' + props.lang + '/our-values/our-community/burgerstobeatms';
  // let promo2URL = '/' + props.lang + '/our-menu/chicken';
    let promo2URL = '/' + props.lang + '/order';


    let imgPromo = (props.lang === 'en') ? imgPromoEn : imgPromoFr;
    //let imgDesc = (props.lang === 'en') ? "Grass Fed Beef" : "bœuf nourrie à l'herbe";
    //let imgDesc = (props.lang === 'en') ? "Kids Pack" : "Le Nouveau régal pour enfants";
    //let imgDesc = (props.lang === 'en') ? "Free Fries with purchase when the Blue Jays Win. Only on the A&W app. " : "Frites gratuites avec achat quand les Toronto Blue Jays gagnent. Seulement sur l'appli A&W.";

    //let imgDesc = (props.lang === 'en') ? "Icy. Creamy. Dreamy." : "GLACES. VELOUTES. ADORES.";
    //let imgDesc = (props.lang === 'en') ? "Croissant egger" : "chef-d’œuf sur croissant";
    //let imgDesc = (props.lang === 'en') ? "Try the new Frozen A&W Root Beer" : "Goûtez à la nouvelle Root Beer A&W™ frappée";
    //let imgDesc = (props.lang === 'en') ? "Try our new iced cold brew and iced latte" : "Essayez notre nouveau café infusé à froid glacé et notre nouveau latte glacé.";
    //let imgDesc = (props.lang === 'en') ? "The usual. Now Frozen. Try our new Frozen A&W Root Beer" : "On a rafraîchi notre classique.";
    //let imgDesc = (props.lang === 'en') ? "Burgers to Beat MS" : "Des burgers pour stopper la SP";
    //let imgDesc = (props.lang === 'en') ? "The good stuff, only smaller" : "Pour les petits amateurs de grands burgers";
    //let imgDesc = (props.lang === 'en') ? "Crunch Crunch Crunch. Try our new Chicken Crunchers" : "MÉGA MÉGA MÉGACROUSTILLANT. Goûtez à nos nouveaux sandwichs au poulet MÉGAcroustillant.";
    //let imgDesc = (props.lang === 'en') ? "Teen Burger®" : "Teen Burger™";

    //let imgDesc = (props.lang === 'en') ? "Take a pastry break" : "c'est l'heure de le gater";
    //let imgDesc = (props.lang === 'en') ? "Proudly serving Pret Organic Coffee" : "Fiers de servir le café biologque Pret";
    //let imgDesc = (props.lang === 'en') ? "Canadian Owned & Operated" : "Enterprise Fièrement Canadienne";
    //let imgDesc = (props.lang === 'en') ? "Got a big app-etite?" : "L'appétit vient en cliquant";
    let imgDesc = (props.lang === 'en') ? "A&W Rewards™ is here!" : "Les Récompenses A&W™ sont arrivées";

    return(

        <Link onClick={() => trackGAEvent("Home Page", "Right Block", "Variable 2")} to={promo2URL} className="sub-promo-2" title={imgDesc}>
            <img src={imgPromo} alt={imgDesc} width="900" height="491" />
        </Link>

    )
}
export default SubPromo2;

// left = <a href={covidUpdateURL} title="Covid 19 Update" onClick={this.trackEvent.bind(this, 'Left Block', 'Variable 1')} className="coupon">
//     <img src={responseimg} alt="Covid 19 Update" onLoad={this.imageLoaded} onError={this.imageLoaded} />
//     </a>;
